<template>
  <div class="profileNav" v-if="isAuthenticated" @mouseover="toggleArrowStyle" @mouseout="toggleArrowStyle" @click="toggleDropdown">
    <!-- {{ user.displayName }} -->
    <ik-image
      loading="lazy"
      :transformation="[{ height: 60, width: 60 }]"
      :src="user.profileImageUrl ? user.profileImageUrl : replacementProfileImage"
      class="profileNav--image"
      :class="$isMobile ? 'profileNav--image--mobile' : ''"
    />
    <!-- <img :src="!navHover ? darkDownArrow : lightDownArrow" class="dropdown-icon" :class="dropDownOpen ? 'dropdown-active' : 'dropdown-icon'" /> -->
    <UserNav v-if="dropDownOpen" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import lightDownArrow from "@/assets/images/down-arrow-light-sharp.png";
import darkDownArrow from "@/assets/images/down-arrow-dark-sharp.png";
import UserNav from "./UserNav";
import CloseComponent from "@/mixins/CloseComponent";

export default {
  name: "UserNavButton",

  mixins: [CloseComponent],

  components: {
    UserNav,
  },
  props: ["parentDiv"],
  data() {
    return {
      buttonText: "Resend email",
      emailSentCounter: 0,
      lightDownArrow: lightDownArrow,
      darkDownArrow: darkDownArrow,
      navHover: false,
      replacementProfileImage:
        "https://ik.imagekit.io/elysiumone/Official/milad-fakurian-bexwsdM5BCw-unsplash__1__mhKxYXNu0o.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1661409930807",
      // loading: true,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      isAuthenticated: (state) => state.auth.authenticationStatus,
    }),
    dropDownOpen() {
      return this.componentOpen; /* from mixin */
    },
  },
  methods: {
    async toggleDropdown() {
      /* wrapper for mixin */
      this.toggleComponent();
    },
    toggleArrowStyle() {
      if (!this.dropDownOpen) {
        this.navHover = !this.navHover;
      }
    },
  },
  // watch: {
  //   "$store.state.auth.ready": function () {
  //     this.loading = false;
  //   },
  // },
};
</script>

<style scoped>
.profileNav {
  border-radius: 360px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 15px;
  /* padding: 2px; */
  background-color: #ffffff94;
  backdrop-filter: blur(30px);
  background: linear-gradient(38deg, #06ffa8 5.39%, #4a3cff 31.4%, #febb3f 70.92%, #c95afd 99.68%);
  background: #c0c0c0d1;
  box-shadow: 0px 1px 4px 0 #afafaf9e;
}
.profileNav--mobile {

}
.profileNav--image {
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  border-radius: 360px;
  padding: 0px;
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
}
.profileNav--image--mobile {
  width: 35px;
  height: 35px;
  border: 1px solid #cecece9e;
}
</style>
